"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const {
  REACT_APP_PATH
} = process.env;
const resolvePath = filename => {
  return filename.charAt(0) === "/" ? REACT_APP_PATH : "";
};
var _default = exports.default = resolvePath;